import { Counter } from '@eg/efectos'
import { Minus, Plus } from 'lucide-react'

type Props = {
  valor: number
  /** Cuántas unidades suma o resta cada pulsación (el múltiplo de la presentación). */
  paso: number
  minimo: number
  alCambiar: (nuevo: number) => void
  /** Nombre accesible del control, por ejemplo «Cantidad de Tono 120». */
  etiqueta: string
  maximo?: number
}

/** Cantidad con botones + y −; el número rueda con Counter. Respeta el mínimo y el múltiplo de la presentación. */
export function ControlCantidad({ valor, paso, minimo, alCambiar, etiqueta, maximo = 99 }: Props) {
  const menos = valor - paso
  const mas = valor + paso
  return (
    <div className="cantidad" role="group" aria-label={etiqueta}>
      <button type="button" className="cantidad__boton" onClick={() => alCambiar(menos)} disabled={menos < minimo} aria-label={`Quitar ${paso}`}>
        <Minus className="icono" strokeWidth={2} aria-hidden="true" />
      </button>
      <span className="cantidad__valor" role="status" aria-live="polite">
        <span className="solo-lectores">{valor} unidades</span>
        <span aria-hidden="true">
          <Counter value={valor} fontSize={20} fontWeight={700} textColor="var(--text)" padding={0} gap={0} intro={false} />
        </span>
      </span>
      <button type="button" className="cantidad__boton" onClick={() => alCambiar(mas)} disabled={mas > maximo} aria-label={`Agregar ${paso}`}>
        <Plus className="icono" strokeWidth={2} aria-hidden="true" />
      </button>
    </div>
  )
}
